export default {"src":"/_next/static/media/video-enhance-promo-bg.02e47afb.gif","height":450,"width":800};